import React from 'react';
import { Pie } from '@ant-design/charts';

const AccountPieChart = ({ data }) => {
  const chartData = data.map(item => ({
    type: item.name,
    value: Math.abs(parseFloat(item.amount)),
  })).filter(item => item.value > 0);

  const config = {
    appendPadding: 10,
    data: chartData,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      type: 'outer',
      content: (data) => {
        return `${data.type} ${(data.percent * 100).toFixed(1)}%`;
      },
    },
    interactions: [{ type: 'element-active' }],
    legend: {
      position: 'bottom',
    },
  };

  return <Pie {...config} style={{ height: '250px' }} />;
};

export default AccountPieChart;
